var React = require('react');

function SmallInfoIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("g",{"fill":"#E5E5E5"},React.createElement("g",null,React.createElement("path",{"d":"M81 0c2.761 0 5 2.239 5 5s-2.239 5-5 5-5-2.239-5-5 2.239-5 5-5zm0 4c-.552 0-1 .448-1 1v3c0 .552.448 1 1 1s1-.448 1-1V5c0-.552-.448-1-1-1zm0-3c-.552 0-1 .448-1 1s.448 1 1 1 1-.448 1-1-.448-1-1-1z","transform":"translate(-184 -77) translate(108 77)"})))));
}

SmallInfoIcon.defaultProps = {"width":"10","height":"10","viewBox":"0 0 10 10"};

module.exports = SmallInfoIcon;

SmallInfoIcon.default = SmallInfoIcon;
